import VueRouter from 'vue-router';
import routes from './routes';
import store from '../Store/index';

const router = new VueRouter({
  mode: 'history',
  base: process.env.baseUrl,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.auth.authenticated) {
      next();
      return;
    }
    next({
      path: '/sign-in',
      query: {
        next: to.fullPath
      }
    });
  } else {
    if (
      store.state.auth.authenticated &&
      to.name !== 'EditLessonPage' &&
      to.name !== 'OpenPageLessonGroupEdit'
    ) {
      next('/');
      return;
    }
    next();
  }
});

router.afterEach((to, from) => {});

router.beforeResolve((to, from, next) => {
  next();
});
export default router;
